import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";

/* eslint-disable camelcase */
import React from 'react';
import { TableActions, ColorBatch } from 'components';
import { actionSearchTypesName, actionSearchTypesColorMap, dateTimeFormat, ACTION_STATUS, actionStatusName, actionStatusColorMap } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";
var detailsBtn = {
  padding: '0.6em',
  '& > i': {
    margin: 0
  }
};

var followUpStyle = function followUpStyle(isOverdue) {
  return {
    color: isOverdue ? '#dc2626' : '#059669',
    fontWeight: isOverdue ? 600 : 400
  };
};

var renderActions = function renderActions(action) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onComplete = _ref.onComplete,
      onSnooze = _ref.onSnooze;

  var isActive = !action.status || action.status === ACTION_STATUS.active;
  var isSnoozed = action.status === ACTION_STATUS.snoozed;
  return ___EmotionJSX(TableActions, {
    mainAction: {
      linkTo: {
        pathname: "/actions/details/".concat(action === null || action === void 0 ? void 0 : action.id),
        state: {
          action: action
        }
      },
      leftIcon: {
        iconName: 'la la-info',
        size: 20
      },
      css: detailsBtn
    },
    actionsList: [(isActive || isSnoozed) && onComplete && {
      label: 'Завърши',
      icon: {
        iconName: 'la la-check-circle'
      },
      onClick: function onClick() {
        return onComplete(action.id);
      }
    }, isActive && onSnooze && {
      label: 'Отложи',
      icon: {
        iconName: 'la la-clock'
      },
      onClick: function onClick() {
        return onSnooze(action.id);
      }
    }]
  });
};

export var actionsListColumns = function actionsListColumns() {
  var callbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return [{
    name: 'Проследяване',
    render: function render(_ref2) {
      var follow_up_date = _ref2.follow_up_date;
      if (!follow_up_date) return '—';
      var isOverdue = new Date(follow_up_date) <= new Date();
      return ___EmotionJSX("span", {
        style: followUpStyle(isOverdue)
      }, new Date(follow_up_date).toLocaleDateString('bg-BG'), isOverdue && ' ●');
    },
    flex: '0 0 110px'
  }, {
    name: 'Действие',
    render: function render(_ref3) {
      var action = _ref3.action;
      return ___EmotionJSX(ColorBatch, {
        type: actionSearchTypesColorMap[action]
      }, actionSearchTypesName[action]);
    },
    flex: '0 0 110px'
  }, {
    name: 'Описание',
    render: function render(_ref4) {
      var note = _ref4.note;
      return note ? "".concat(note.slice(0, 60)).concat(note.length > 60 ? '...' : '') : '—';
    },
    flex: '1 1 120px'
  }, {
    name: 'Дата',
    value: 'created_at',
    dateTimeFormat: dateTimeFormat,
    flex: '0 0 120px'
  }, {
    name: 'Служител',
    value: 'employee.name',
    flex: '0 0 130px'
  }, {
    name: 'Статус',
    render: function render(_ref5) {
      var status = _ref5.status;
      var s = status || ACTION_STATUS.active;
      return ___EmotionJSX(ColorBatch, {
        type: actionStatusColorMap[s]
      }, actionStatusName[s]);
    },
    flex: '0 0 90px'
  }, {
    name: '',
    render: function render(action) {
      return renderActions(action, callbacks);
    },
    flex: '0 0 80px'
  }].filter(Boolean);
};